<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.player" :value="rulePlayer"/>
    </div>
  </div>
</template>

<script>
import one from '../../assets/gamerule/11hilo/1.png';
import twoOne from '../../assets/gamerule/11hilo/2-1.png';
import twoTwo from '../../assets/gamerule/11hilo/2-2.png';
import threeOne from '../../assets/gamerule/11hilo/3-1.png';
import threeTwo from '../../assets/gamerule/11hilo/3-2.png';
import fourOne from '../../assets/gamerule/11hilo/4-1.png';
import fourTwo from '../../assets/gamerule/11hilo/4-2.png';
import fiveOne from '../../assets/gamerule/11hilo/5-1.png';
import fiveTwo from '../../assets/gamerule/11hilo/5-2.png';
import sixOne from '../../assets/gamerule/11hilo/6-1.png';
import sixTwo from '../../assets/gamerule/11hilo/6-2.png';
import hiloboard from '../../assets/gamerule/11hilo/hilo_board.png';
import player3 from '../../assets/gamerule/11hilo/player 3.png';
import player2 from '../../assets/gamerule/11hilo/player 2.png';
import player1 from '../../assets/gamerule/11hilo/player 1.png';

export default {
  name: 'rule_11hilo',
  data() {
    return {
      ruleHeader: {
        gameName: 'ไฮโล (Hilo)',
        boardImg: hiloboard,
      },
      ruleTitle: {
        payRate: 'อัตราจ่าย',
        rule: 'กติกา',
        player: 'แต้มไพ่',

      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97 (หากผู้เล่นลงเดิมพัน 100 บาท และได้รับ ชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท)',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: '1. จำนวนผู้เล่นต่อ 1 ห้อง มีได้ 2-50 คน เมื่อเข้ามาในห้องแล้วจะเริ่มเล่นได้ทันที',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: one,
          class: 'w-40',
        },
        {
          type: 'text',
          text: '2. วิธีเดิมพันมี 2 ประเภท คือ เต็งและคู่ ผู้เล่นมีเวลา 30 วินาที ในการวางเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: twoOne,
          class: 'w-100',
          image2: twoTwo,
        },
        {
          type: 'text',
          text: '3. เมื่อหมดเวลาระบบจะทำการสุ่มออกผลโดยอัตโนมัติ',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: threeOne,
          class: 'w-100',
          image2: threeTwo,
        },
        {
          type: 'text',
          text: '4. หากลูกค้าเดิมพันเต็ง(เดี่ยว) แล้วผลออกมาตรงตามเดิมพัน หากออก 1 ลูกจ่าย 1 เท่า ออก 2 ลูก จ่าย 2 เท่าออก 3 ลูก จ่าย 3 เท่า : เช่น ลูกค้าเดิมพัน “2”100 บาท หากผลออกเป็น “2” “2” “4” ลูกค้าจะได้รับเงิน 200',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: fourOne,
          class: 'w-100',
          image2: fourTwo,
        },
        {
          type: 'text',
          text: '5. หากลูกค้าเดิมพันโต๊ด(คู่) แล้วผลออกมาตรงตามที่เดิมพันไปจ่าย 5 เท่า เช่น เดิมพัน “2” “3”จำนวน 200 บาท หากผลทอยลูกเต๋าออกเป็น “2” “3” “6”ลูกค้าจะได้รับเงิน 1,000 บาท (5 เท่า) หากแทง ‘11 ไฮโลได้ 1,400 บาท (7 เท่า)',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: fiveOne,
          class: 'w-100',
          image2: fiveTwo,
        },
        {
          type: 'text',
          text: '6. หากลูกค้าเดิมพัน “123” “456” แล้วผลออกมาเรียงตรงตามที่เดิมพันไปจ่าย 5 เท่า ถ้าเรียงสองตัว จ่าย 1 เท่าเช่น  เดิมพัน “123” จำนวน 100 บาท หากผลทอยลูกเต๋าออกเป็น “1” “2” “3” ลูกค้าจะได้รับเงิน 500 บาท (5 เท่า)หากออก “1” “2” “5” ลูกค้าจะได้รับเงิน 100 บาท (1 เท่า)',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: sixOne,
          class: 'w-100',
          image2: sixTwo,
        },
      ],
      rulePlayer: [
        {
          type: 'text',
          text: 'ผู้เล่นสามารถเลือกชิปในการลงเดิมพันได้เเละถ้าหากจำนวนเงินของผู้เล่นน้อยกว่าชิปจะไม่สามารถทำการเลือกชิป ที่มีมูลค่าสูงกว่าได้',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: player1,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'การเดิมพันในแต่ละรอบจะอิงจากยอดขั้นต่ำ(Minimum)กับยอดเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: player2,
          class: 'w-20',
        },
        {
          type: 'text',
          text: 'สามารถกดปุ่ม ยืนยัน หรือ ยกเลิกได้ถ้าไม่กดยืนยันถือว่าไม่ได้ทำการเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: player3,
          class: 'w-20',
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
